import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { Modal, Box, IconButton, Grid } from "@mui/material";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "../pages/doctor-console/DoctorConsole.scss";
import CloseIcon from "@mui/icons-material/Close";
import { StyledButton } from "../pages/doctor-console/StyledComponents";
import { StyledModal } from "../pages/doctor-console/StyledComponents";

const ConsentModal = ({
  isOpen,
  onRequestClose,
  getPatientDataConsent,
  patientData,
  onSubmitClose,
}) => {
  console.log("Patient Data from Consent Page", patientData);
  const purposeOptionsMap = {
    "": "Select",
    CAREMGT: "Care Management",
    BTG: "Break the Glass",
    PUBHLTH: "Public Health",
    HPAYMT: "Healthcare Payment",
    DSRCH: "Disease Specific Healthcare Research",
    // PATRQT: "Self Requested",
  };

  const purposeOptions = Object.keys(purposeOptionsMap);

  const infoTypeOptions = {
    "Select All": "Select All",
    Prescription: "Prescription",
    "OP Consultation": "OPConsultation",
    "Diagnostic Report": "DiagnosticReport",
    "Discharge Summary": "DischargeSummary",
    "Immunization Record": "ImmunizationRecord",
    "Health Document": "HealthDocumentRecord",
    "Wellness Record": "WellnessRecord",
  };
  const [healthInfoTypeError, setHealthInfoTypeError] = useState(false);
  const validateDates = () => {
    const fromDate = new Date(formData.from);
    const toDate = new Date(formData.to);
    const expiryDate = new Date(formData.expiry);
    const currentDate = new Date();
    if (toDate < fromDate) {
      toast.error("To date must be greater than From date.");
      return false;
    }

    if (expiryDate <= currentDate) {
      toast.error("Consent expiry date must be today or a future date.");
      return false;
    }
    if (expiryDate < toDate) {
      toast.error("Consent expiry date must be greater than to date.");
      return false;
    }
    return true;
  };

  const formatDate = (dateString, dateType) => {
    const date = new Date(dateString);
    const currentDate = new Date();

    console.log("Before", date);

    // Check if the date is the same as the current date
    const isSameDay =
      date.getDate() === currentDate.getDate() &&
      date.getMonth() === currentDate.getMonth() &&
      date.getFullYear() === currentDate.getFullYear();

    if (dateType === "from") {
      date.setTime(date.getTime() - (5 * 60 * 60 * 1000 + 30 * 60 * 1000));
    }
    if (dateType === "to") {
      console.log("Is Same Day", isSameDay);
      console.log(
        "To Date",
        date.getDate(),
        date.getMonth(),
        date.getFullYear()
      );
      console.log(
        "Current",
        currentDate.getDate(),
        currentDate.getMonth(),
        currentDate.getFullYear()
      );
      if (!isSameDay) {
        console.log("Not Same Day");
        //instead of 23 we use 28 (+5) and 59 we use 89(+30) because of GMT
        date.setHours(23, 59, 0, 0); // Set to 11:59 PM
      } else {
        date.setHours(currentDate.getHours());
        date.setMinutes(currentDate.getMinutes());
        date.setSeconds(0);
        date.setMilliseconds(0);
      }
    } else if (dateType === "expiry") {
      date.setHours(date.getHours());
      date.setMinutes(date.getMinutes());
      date.setSeconds(0);
      date.setMilliseconds(0);
    }

    let formattedDate = date.toISOString();

    console.log("After", formattedDate);
    return formattedDate;
  };

  const [formData, setFormData] = useState({
    purpose: "",
    from: "",
    to: "",
    infoTypes: [],
    expiry: "",
    abha_id: null,
  });

  useEffect(() => {
    console.log("Useeffect called from consent creation modal");
    const now = new Date();
    // Adjust to IST (UTC +5:30)
    const offsetIST = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
    const nowIST = new Date(now.getTime() + offsetIST);
    const threeMonthsAgo = new Date(nowIST);
    threeMonthsAgo.setMonth(nowIST.getMonth() - 3);
    const threeDaysLater = new Date(nowIST);
    threeDaysLater.setDate(nowIST.getDate() + 3);

    setFormData({
      purpose: "",
      from: threeMonthsAgo.toISOString().slice(0, 10), // format to YYYY-MM-DD
      to: now.toISOString().slice(0, 10), // format to YYYY-MM-DD
      infoTypes: [],
      expiry: threeDaysLater.toISOString().slice(0, 16), // format to YYYY-MM-DDTHH:MM
      abha_id: null,
    });
  }, [isOpen]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log("Name and Value", value);
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    if (name === "Select All") {
      if (checked) {
        let infos = Object.entries(infoTypeOptions).map(([, val]) => val);
        setFormData({
          ...formData,
          infoTypes: [...infos],
        });
      } else {
        setFormData({
          ...formData,
          infoTypes: [],
        });
      }
      return;
    }
    const value = infoTypeOptions[name];
    console.log("Info Types", value);
    if (checked) {
      setFormData((prevData) => {
        const updatedInfoTypes = [...prevData.infoTypes, value];

        // Check if all options are selected
        const allSelected =
          Object.keys(infoTypeOptions).length - 1 === updatedInfoTypes.length;
        if (allSelected) {
          updatedInfoTypes.push("Select All");
        }

        return {
          ...prevData,
          infoTypes: updatedInfoTypes,
        };
      });
    } else {
      setFormData({
        ...formData,
        infoTypes: formData.infoTypes.filter(
          (type) => type !== value && type !== "Select All"
        ),
      });
    }
  };
  console.log("Formdata", formData);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateDates()) {
      return;
    }
    if (formData.infoTypes.length === 0) {
      setHealthInfoTypeError(true);
      return;
    }
    setHealthInfoTypeError(false);
    const newFormData = {
      ...formData,
      infoTypes: formData.infoTypes.filter((val) => val !== "Select All"),
      to: formatDate(formData.to, "to"),
      from: formatDate(formData.from, "from"),
      expiry: formatDate(formData.expiry, "expiry"),
    };
    var newFormDataArr = [];
    newFormDataArr.push(newFormData);
    if (patientData) {
      getPatientDataConsent(patientData.abha_id, newFormDataArr);
    } else {
      getPatientDataConsent(formData.abha_id, newFormDataArr);
    }

    console.log("newFormData", newFormData);
    setFormData({
      purpose: "",
      from: "",
      to: "",
      infoTypes: [],
      expiry: "",
      abha_id: null,
    });
    onSubmitClose();
  };

  const handleDateChange = (name, date) => {
    setFormData({ ...formData, [name]: date });
  };
  return (
    <StyledModal
      open={isOpen}
      handleClose={onRequestClose}
      title="Generate Consent Request"
    >
      <Box sx={{ padding: 2 }}>
        {/* <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton onClick={onRequestClose}>
            <CloseIcon />
          </IconButton>
        </div>
        <h1 className="consent-history-modal-title">
          Generate Consent Request
        </h1> */}

        <Form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Form.Group>
                <Form.Label>Name</Form.Label>
                <Form.Control
                  disabled={patientData}
                  name="name"
                  value={patientData ? patientData.name : null}
                />
              </Form.Group>
            </Grid>

            <Grid item xs={6}>
              <Form.Group>
                <Form.Label>Gender</Form.Label>
                <Form.Control
                  disabled={patientData}
                  name="gender"
                  value={patientData ? patientData.gender : null}
                />
              </Form.Group>
            </Grid>

            <Grid item xs={6}>
              <Form.Group>
                <Form.Label>DOB</Form.Label>
                <Form.Control
                  disabled={patientData}
                  name="dob"
                  value={patientData ? patientData.dob : null}
                />
              </Form.Group>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Form.Group>
                <Form.Label className="required-label">ABHA Address</Form.Label>
                <Form.Control
                  disabled={patientData}
                  name="abha_id"
                  required={patientData == null}
                  value={patientData ? patientData.abha_id : null}
                  onChange={handleInputChange}
                />
              </Form.Group>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Form.Group>
                <Form.Label>ABHA Number</Form.Label>
                <Form.Control
                  disabled={patientData}
                  name="abhaNo"
                  value={
                    patientData
                      ? patientData.abha_no && patientData.abha_no.length > 0
                        ? patientData.abha_no
                        : "Not Available"
                      : null
                  }
                />
              </Form.Group>
            </Grid>

            <Grid item xs={12}>
              <Form.Group>
                <Form.Label className="required-label">
                  Purpose of Request
                </Form.Label>
                <Form.Control
                  as="select"
                  name="purpose"
                  value={formData.purpose}
                  onChange={handleInputChange}
                  required
                >
                  {purposeOptions.map((option, index) => (
                    <option key={index} value={option}>
                      {purposeOptionsMap[option]}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Form.Group className="form-group form-group-date">
                <Form.Label className="required-label">
                  Health Info From
                </Form.Label>
                <i
                  className="icon-calendar form-group-icon"
                  style={{ marginTop: "24px" }}
                ></i>
                <Form.Control
                  style={{ paddingLeft: "20px" }}
                  type="date"
                  name="from"
                  value={formData.from}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Form.Group className="form-group form-group-date">
                <Form.Label className="required-label">
                  Health Info To
                </Form.Label>
                <i
                  className="icon-calendar form-group-icon"
                  style={{ marginTop: "24px" }}
                ></i>
                <Form.Control
                  style={{ paddingLeft: "20px" }}
                  type="date"
                  name="to"
                  value={formData.to}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
            </Grid>

            <Grid item xs={12}>
              <Form.Group>
                <Form.Label className="required-label">
                  Health info type
                </Form.Label>
                <Grid container spacing={2}>
                  {Object.keys(infoTypeOptions).map((option, index) => (
                    <Grid item xs={6} key={index}>
                      <Form.Check
                        type="checkbox"
                        name={option}
                        label={option}
                        checked={formData.infoTypes.includes(
                          infoTypeOptions[option]
                        )}
                        onChange={handleCheckboxChange}
                      />
                    </Grid>
                  ))}
                </Grid>
                {healthInfoTypeError && (
                  <p className="text-danger">
                    Please select at least one health info type.
                  </p>
                )}
              </Form.Group>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Form.Group className="form-group form-group-date">
                <Form.Label className="required-label">
                  Consent Expiry
                </Form.Label>
                <i
                  className="icon-calendar form-group-icon"
                  style={{ marginTop: "24px" }}
                ></i>
                <Form.Control
                  style={{ paddingLeft: "20px" }}
                  type="datetime-local"
                  name="expiry"
                  value={formData.expiry}
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
            </Grid>

            <Grid item xs={12} textAlign="center">
              {/* <StyledButton bgColor="#121959" type="submit">
                Submit
              </StyledButton> */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                <button
                  type="submit"
                  className="btn btn__secondary btn__rounded small-btn"
                >
                  <span>Submit</span> <i className="icon-arrow-right"></i>
                </button>
              </div>
            </Grid>
          </Grid>
        </Form>
      </Box>
    </StyledModal>
  );
};

export default ConsentModal;
